<template>
  <v-tooltip v-bind="$attrs" bottom v-if="tooltip" min-width="300" max-width="300">
    <template v-bind="$attrs" v-slot:activator="{ on }">
      <v-icon small v-on="on" :color="color ? color : 'grey lighten-1'">{{ icon ? icon : "fas fa-question-circle" }}</v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  inheritAttrs: true,

  props: {
    tooltip: {
      type: String
    },
    color: {
      type: String
    },
    icon: {
      type: String
    }
  }
}
</script>
